import { defineStore } from 'pinia';
import { readonly, ref } from 'vue';
import { type Shop } from '@/js/lib/_env';
import { credentials } from '@/js/lib/api/user';
import { useUserCredentialStore } from './user-credential';

export const useShopStore = defineStore('shop', () => {
  const { hasCredential } = useUserCredentialStore();
  const isOnVacation = ref(false);
  const firstListedAt = ref<Date | undefined>(undefined);
  const lastListedAt = ref<Date | undefined>(undefined);
  const maxListingCount = ref<number>(undefined);

  function assignShop(shop: Shop) {
    isOnVacation.value = hasCredential(credentials.seller) ? Boolean(shop.is_on_vacation) : false;

    if (shop.first_listed_at) {
      firstListedAt.value = new Date(shop.first_listed_at * 1000);
    }
    if (shop.last_listed_at) {
      lastListedAt.value = new Date(shop.last_listed_at * 1000);
    }
    if (shop.max_listing_count) {
      maxListingCount.value = shop.max_listing_count;
    }
  }

  return {
    isOnVacation: readonly(isOnVacation),
    firstListedAt: readonly(firstListedAt),
    lastListedAt: readonly(lastListedAt),
    maxListingCount: readonly(maxListingCount),
    assignShop,
  };
});
